/**
 * Tytuł karty przeglądarki z widoku (fala 9, grupa 143; WCAG 2.4.2): każdy
 * widok miał ten sam tytuł z index.html. Bez nazwy strony — nazwa produktu.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function useDocumentTitle(page?: string | null): void {
  const { t, i18n } = useTranslation()
  const title = page ? t('app.documentTitlePage', { page }) : t('app.documentTitle')
  useEffect(() => {
    document.title = title
  }, [title, i18n.resolvedLanguage])
}
